import { render, staticRenderFns } from "./roleAssignFunctionalPermissions.vue?vue&type=template&id=1bca3606&scoped=true&"
import script from "./roleAssignFunctionalPermissions.vue?vue&type=script&lang=ts&"
export * from "./roleAssignFunctionalPermissions.vue?vue&type=script&lang=ts&"
import style0 from "./roleAssignFunctionalPermissions.vue?vue&type=style&index=0&id=1bca3606&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bca3606",
  null
  
)

export default component.exports